import { updateUserTelegramChatId } from "@lib/api/telegramBotConfigs";
import { AppConst } from "@lib/constants";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import { setAuth } from "@lib/redux/slices/auth";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

declare global {
  interface Window {
    Telegram: {
      WebApp: {
        initData: any;
      };
    };
    TelegramWebviewProxy: any;
  }
}

export default function AppPwaProvider() {
  const dispatch = useTypedDispatch();
  const user = useTypedSelector((state) => state.auth.user);
  // const [loadJs, setLoadJs] = useState(false);

  const getParams = (key: string) => {
    const url = window.location.href;
    const split = url?.split("?");
    const params = split?.[1]?.split("&");
    return params?.find((param) => param.startsWith(key))?.split("=")[1];
  };

  const botId = getParams(AppConst.TELEGRAM_BOT_QUERY_ID);

  const { mutate: mutateTelegramChatId, isSuccess: isTelegramSuccess } =
    useMutation({
      mutationFn: (payload: any) => updateUserTelegramChatId(payload),
      onError: (error: any) => {
        if (error?.response?.status === 409) {
          toast.error("TELEGRAM.TELEGRAM_CONFLICT_ERROR_OCCURRED");
          dispatch(setAuth(null));
        }
      },
    });

  const updateTelegramChatId = () => {
    const botConfigId = localStorage.getItem(AppConst.TELEGRAM_BOT_QUERY_ID);
    const telegramPayload = window?.Telegram?.WebApp?.initData;

    if (telegramPayload && botConfigId) {
      mutateTelegramChatId({ telegramPayload, interactedBots: [botConfigId] });
    }
  };

  // useLayoutEffect(() => {
  //   if (window?.TelegramWebviewProxy !== undefined && !loadJs) {
  //     // @ts-ignore
  //     import("https://telegram.org/js/telegram-web-app.js").then(() => {
  //       setLoadJs(true);
  //     });
  //   }
  // }, []);

  useEffect(() => {
    // if (!loadJs) return;

    if (botId) {
      localStorage.setItem(AppConst.TELEGRAM_BOT_QUERY_ID, botId);

      if (user?.id) {
        updateTelegramChatId();
        return;
      }
    }

    const botConfigId = localStorage.getItem(AppConst.TELEGRAM_BOT_QUERY_ID);

    if (botConfigId && !botId && user?.id && !isTelegramSuccess) {
      updateTelegramChatId();
    }
  }, [botId, user?.id]);

  return null;
}
